import React from 'react';
import {Button, Modal} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEraser} from "@fortawesome/free-solid-svg-icons";
import GeraeteNewModalTable from "./GeraeteNewModalTable";

function GeraeteModal(props) {
    return (<Modal show={props.show} onHide={props.handleClose}
                   aria-labelledby="contained-modal-title-vcenter"
                   centered>
        <Modal.Header closeButton>
            <Modal.Title>Neu Gerät</Modal.Title>
        </Modal.Header>
        <Modal.Body className="handwai-dark">
            <GeraeteNewModalTable newDeviceData={props.devicesData}
                                  setIsChange={props.setIsChange}
                                  geraeteDataInfo={props.geraeteDataInfo}
                                  setGeraeteData={props.setGeraeteData}/>
        </Modal.Body>
        <Modal.Footer>
            <Button size='lg' block className='handwai-btn-create'
                    onClick={props.handleClose}> <FontAwesomeIcon
                icon={faEraser}/> &emsp;
                Schließen
            </Button>
        </Modal.Footer>
    </Modal>);
}

export default GeraeteModal;